import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import FormFields from "../../components/common/FormFields";
import { SUB_COUNTY } from "../../utils/constants";
import {
  createColumn,
  createEditAction,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_SUB_COUNTIES } from "../../utils/urls";
import useGet from "../common/useGet";
import { API_COUNTIES } from "../../utils/apis";

export const useSubCounties = () => {
  const tableColumns = () => [
    createColumn("name", true, "Sub County"),
    createColumn("county_name", true, "County"),
    createColumn("actions", false, "Actions"),
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        actions: (
          <FormActions
            actions={[createEditAction(URL_SUB_COUNTIES, item?.id)]}
          />
        ),
      };
    }),
  ];

  const formRoute = getForm(URL_SUB_COUNTIES);

  return { tableData, tableColumns, formRoute };
};

export const useSubCountyForm = () => {
  const { loadData, loading, data: countyData } = useGet();
  useEffect(() => loadData({ api: API_COUNTIES }), []);
  const fields: any = [
    {
      field_name: "parent",
      type: "select",
      label: "county",
      props: { required: true },
      options_data: countyData?.results,
      loading,
    },
    {
      field_name: "name",
      label: "SubCounty name",
      type: "text",
      props: { required: true },
    },
  ];
  const sections: any = [
    {
      title: "SubCounty details",
      fields,
    },
  ];

  const redirect = getRegister(URL_SUB_COUNTIES);

  const defaultValues = { location_type: SUB_COUNTY };

  return { fields, sections, redirect, defaultValues };
};

export const SubCountyForm = ({
  form,
  error,
  updateFormValue,
  onChange,
}: any) => {
  const { fields } = useSubCountyForm();
  return (
    <FormFields
      fields={fields}
      error={error}
      form={form}
      updateFormValue={updateFormValue}
      onChange={onChange}
    />
  );
};
